<template>
  <div class="matrix-compose">
    <matrix-form :rows="issue.rows">
      <template v-slot:content="{ row }">
        <div v-for="item in issue.items" :key="item.id" class="mb-2 last:mb-0">
          <div class="my-1 rich-text-wrap" v-html="item.content.richText"></div>
          <compose-item
            :row="row"
            :col="item"
            :cell="issue.getCellByItemId(item.id)"
            :cache-value="issue.getValueByRowAndCol(row, item)"
            @change="onChangeValue"
          />
          <template v-if="row.errMap[item.id]">
            <span class="text-red mt-1 text-small">{{ row.errMap[item.id] }}</span>
          </template>
        </div>
      </template>
    </matrix-form>
  </div>
</template>

<script>
import MatrixForm from '@/questions/components/MatrixForm'
import ComposeItem from '@/questions/matrix/ComposeItem'

export default {
  name: 'MatrixCompose',
  changeExpr: 'issue.value',
  components: { ComposeItem, MatrixForm },
  methods: {
    onChangeValue(value) {
      this.issue.addValue(value.slice())
    }
  }
}
</script>

<style scoped></style>
